module.exports = __webpack_public_path__ + "static/media/store.0ad0e29a.svg";